import { masked } from 'design-system/input/text/masked';

const maskedAsDate = masked('__/__/____');

export { maskedAsDate };
